import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import _ from 'lodash';
import {connect} from 'react-redux';
import AbstractListerField from './AbstractListerField';
import {stringToDashed} from 'cl-automation-utils';

export default class ListerRadioButtons extends AbstractListerField {
  updateFieldValue = (event, value) => {
    const {onChange} = this.props;
    onChange(value);
  };

  render() {
    const {disabled, fieldName, value, dataSet, id} = this.props;
    const radioButtons = _.map(dataSet, (data, key) => {
      return (
        <RadioButton
          id={`${id}-${stringToDashed(key)}`}
          label={key}
          key={key}
          value={data}
          style={{width: 200, marginBottom: 5}}
          disabled={disabled}
        />
      );
    });
    return (
      <div style={{paddingTop: 15}}>
        <div
          style={{height: 0, width: 0}}
          dangerouslySetInnerHTML={{__html: '&nbsp'}} // cheat baseline, looks like IE takes the baseline as the bottom of the first child.
        />
        <RadioButtonGroup
          labelPosition="right"
          valueSelected={value}
          onChange={this.updateFieldValue}
          name={fieldName}
          disabled={disabled}
        >
          {radioButtons}
        </RadioButtonGroup>
      </div>
    );
  }
}

ListerRadioButtons.propTypes = {
  fieldName: PropTypes.string,
  onChange: PropTypes.func,
  floatingLabelText: PropTypes.string,
  required: PropTypes.bool,
};
